import { forwardRef } from 'react';
import { ReactKit } from '@team/react';
import { RootComponent } from '../../services/root-component';
import { VisuallyHidden } from '../../services/visually-hidden';
import { Spinner } from './components/spinner';
import { Props } from './types';
import { Size } from './enums';
import css from './style.module.css';

export const Layout = forwardRef<HTMLSpanElement, Props>(function Component(
  { size = Size.SMALL, children = 'Загружается...', ...props },
  forwardedRef
) {
  return (
    <RootComponent
      {...props}
      Component="span"
      baseClassName={css.root}
      role="status"
      ref={forwardedRef}
    >
      <Spinner size={size} />

      {ReactKit.hasNode(children) && (
        <VisuallyHidden>{children}</VisuallyHidden>
      )}
    </RootComponent>
  );
});
